import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import {
  borderMixin,
  type ColumnTable as ColumnTableType,
  columnTableMixin
} from './column-table-mixin';

export const ColumnTable = styled.div.attrs<ColumnTableType>({
  className: createReadableClass({
    component: 'column-classic-table',
    element: 'container'
  })
})`
  ${borderMixin}
  ${columnTableMixin}
`;
